module.exports = __webpack_public_path__ + "static/tg-icon-fbcafb8a43a7f39a2577c24b952283f7.png";